import { render, staticRenderFns } from "./StatisticsBafsTourobsFilter.vue?vue&type=template&id=0a1b4de0&scoped=true"
import script from "./StatisticsBafsTourobsFilter.vue?vue&type=script&lang=js"
export * from "./StatisticsBafsTourobsFilter.vue?vue&type=script&lang=js"
import style0 from "./StatisticsBafsTourobsFilter.vue?vue&type=style&index=0&id=0a1b4de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1b4de0",
  null
  
)

export default component.exports